class ChiefComplaint {
  constructor(title, code, category) {
    this.title = title;
    this.code = code;
    this.category = category;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allChiefComplaints: [],
      allChiefComplaintsForOther: [],
      chiefComplaint: new ChiefComplaint('', '', null),
      chiefComplaintPaginationList: [],
    };
  },
  methods: {
    getListOfChiefComplaintsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllChiefComplaints', "?IsActive=true").then(() => {
        if (this.$store.state.chiefComplaintModule.successFlag) {
          this.allChiefComplaintsForOther =
            this.$store.state.chiefComplaintModule.allChiefComplaints;
          if (this.$route.name == 'addTriageAnswer') {
            this.allChiefComplaintsForOther.forEach((c) => (c.class = 'mr-3 mt-2'));
            //edit
            if (this.isAdd == false) {
              this.getTriageAnswerFunction(this.answerId);
            }
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfChiefComplaintsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfChiefComplaintsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllChiefComplaints: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllChiefComplaints').then(() => {
        if (this.$store.state.chiefComplaintModule.successFlag) {
          // this.allChiefComplaints = this.$store.state.chiefComplaintModule.allChiefComplaints;

          this.allChiefComplaints = Array.isArray(this.$store.state.chiefComplaintModule.allChiefComplaints)
            ? this.$store.state.chiefComplaintModule.allChiefComplaints
            : [];

          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllChiefComplaints();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllChiefComplaints();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfChiefComplaintsWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getChiefComplaintsWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          title: this.searchText,
          category: this.searchCategory,
        })
        .then(() => {
          if (this.$store.state.chiefComplaintModule.successFlag) {
            this.chiefComplaintPaginationList = [];
            let temp = this.$store.state.chiefComplaintModule.chiefComplaints;
            for (let i = 0; i < temp.length; i++) {
              let isActive = true;
              if (temp[i].isActive === false) {
                isActive = false;
              }
              let categoryText = '-';
              if (temp[i].category === 0) {
                categoryText = 'بیماری';
              } else if (temp[i].category === 1) {
                categoryText = 'حادثه';
              }
              this.chiefComplaintPaginationList.push({
                counter: i + 1,
                title: temp[i].title ? temp[i].title : '-',
                code: temp[i].code ? temp[i].code : '-',
                category: categoryText,
                status: isActive,
                id: temp[i].id,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.chiefComplaintModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.chiefComplaintModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.chiefComplaintModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.chiefComplaintModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfChiefComplaintsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfChiefComplaintsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addChiefComplaintFunction: function () {
      if (!this.chiefComplaint.title) {
        this.snackText = 'عنوان تشخیص احتمالی پرستار نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.chiefComplaint.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان تشخیص احتمالی پرستار نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.chiefComplaint.category === undefined || this.chiefComplaint.category === null) {
        this.snackText = 'دسته بندی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.chiefComplaint.isActive = this.isActive;
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addChiefComplaint', this.chiefComplaint).then(() => {
        if (this.$store.state.chiefComplaintModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' تشخیص احتمالی پرستار با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.isActive = false;
          this.chiefComplaint = new ChiefComplaint('', '', null);
          this.getListOfChiefComplaintsWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addChiefComplaintFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addChiefComplaintFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getChiefComplaintFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getChiefComplaint', id).then(() => {
        if (this.$store.state.chiefComplaintModule.successFlag) {
          let temp = this.$store.state.chiefComplaintModule.chiefComplaint;
          this.chiefComplaint.id = temp.id;
          this.chiefComplaint.title = temp.title;
          this.chiefComplaint.code = temp.code;
          this.chiefComplaint.category = temp.category;
          if (temp.isActive == false) {
            this.isActive = false;
          } else {
            this.isActive = true;
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getChiefComplaintFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getChiefComplaintFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editChiefComplaintFunction: function () {
      if (!this.chiefComplaint.title) {
        this.snackText = 'عنوان تشخیص احتمالی پرستار نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.chiefComplaint.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان تشخیص احتمالی پرستار نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.chiefComplaint.category === undefined || this.chiefComplaint.category === null) {
        this.snackText = 'دسته بندی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.chiefComplaint.isActive = this.isActive;
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editChiefComplaint', this.chiefComplaint).then(() => {
        if (this.$store.state.chiefComplaintModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfChiefComplaintsWithPagination();
          this.snackText = ' تشخیص احتمالی پرستار با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.isActive = false;
          this.chiefComplaint = new ChiefComplaint('', '', null);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editChiefComplaintFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editChiefComplaintFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteChiefComplaintFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteChiefComplaint', this.chiefComplaintId).then(() => {
        if (this.$store.state.chiefComplaintModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfChiefComplaintsWithPagination();
          this.snackText = ' تشخیص احتمالی پرستار با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chiefComplaintModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteChiefComplaintFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.chiefComplaintModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteChiefComplaintFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.chiefComplaintModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
